module.exports = __webpack_public_path__ + "img/ig-footer.fe172aaf.svg";